import React, { useState, useEffect, useRef } from 'react';
import './GallerySection.css';

const GallerySection = () => {
  const [loadedImages, setLoadedImages] = useState(new Set());
  const imageRefs = useRef([]);

  useEffect(() => {
    // Preload hero background image
    const heroImg = new Image();
    heroImg.src = '/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp';
    
    // Intersection Observer for lazy loading gallery images
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const imgSrc = entry.target.dataset.src;
            if (imgSrc && !loadedImages.has(imgSrc)) {
              const img = new Image();
              img.src = imgSrc;
              img.onload = () => {
                setLoadedImages((prev) => new Set([...prev, imgSrc]));
                entry.target.style.backgroundImage = `url(${imgSrc})`;
                entry.target.classList.add('loaded');
              };
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: '50px' }
    );

    imageRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      imageRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [loadedImages]);
  const galleryItems = [
    {
      id: 1,
      title: "Baby Julian",
      category: "Baby Shower",
      image: '/images/BabyShower/Gemini_Generated_Image_2e5abf2e5abf2e5a.webp',
      description: 'Elegant baby shower setup with gold accents'
    },
    {
      id: 2,
      title: "Meera",
      category: "Anniversary",
      image: '/images/AnniversaryImages/Gemini_Generated_Image_wdkjmtwdkjmtwdkj.webp',
      description: 'Romantic anniversary celebration'
    },
    {
      id: 3,
      title: "Mickey Mouse Theme",
      category: "Birthday",
      image: '/images/KidBirthdayDecorations/Gemini_Generated_Image_kap93gkap93gkap9.webp',
      description: 'Fun themed birthday party'
    },
    {
      id: 4,
      title: "Bride to Be",
      category: "Bridal Shower",
      image: '/images/AnniversaryImages/Gemini_Generated_Image_p740z7p740z7p740.webp',
      description: 'Elegant bridal shower decoration'
    },
    {
      id: 5,
      title: "Happy Birthday",
      category: "Birthday",
      image: '/images/BirthdayImages/freepik__35mm-film-photography-luxury-indian-birthday-decor__13647.webp',
      description: 'Luxury birthday celebration'
    },
    {
      id: 6,
      title: "Happy Anniversary",
      category: "Anniversary",
      image: '/images/AnniversaryImages/Gemini_Generated_Image_yx4r2uyx4r2uyx4r.webp',
      description: 'Golden anniversary celebration'
    }
  ];

  return (
    <section id="gallery" className="gallery-section">
      <div 
        className="gallery-hero"
        style={{
          backgroundImage: `url('/images/banners/freepik__the-style-is-candid-image-photography-with-natural__24137.webp')`
        }}
      >
        <div className="gallery-hero-overlay"></div>
        <div className="gallery-hero-content">
          <h2 className="gallery-hero-text">LET'S GET OUR BALLOON ON!</h2>
          <h3 className="gallery-hero-subtext">From Birthday To Anniversary</h3>
        </div>
      </div>
      
      <div className="gallery-container">
        <div className="gallery-header">
          <h2 className="gallery-title">Our Recent Work</h2>
          <p className="gallery-subtitle">Transforming celebrations into unforgettable memories</p>
        </div>
        
        <div className="gallery-grid">
          {galleryItems.map((item, index) => (
            <div 
              key={item.id} 
              className="gallery-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="gallery-image-wrapper">
                <div 
                  ref={(el) => (imageRefs.current[index] = el)}
                  className="gallery-image"
                  data-src={item.image}
                  style={loadedImages.has(item.image) ? { backgroundImage: `url(${item.image})` } : {}}
                >
                  <div className="gallery-overlay">
                    <div className="gallery-info">
                      <span className="gallery-category">{item.category}</span>
                      <h3 className="gallery-item-title">{item.title}</h3>
                      <p className="gallery-item-description">{item.description}</p>
                      <a 
                        href="https://wa.me/9166007718" 
                        className="gallery-cta-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Get Quote
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
